import { css } from 'aphrodite';
import { useState } from 'react';
import { RejectionCategory } from '../../../../extViewmodels';
import { baseStyleSheet } from '../../../styles/styles';
import { Modal } from '../../Modal';
import { ISelectBoxOption, SelectBox } from '../../SelectBox';
import { WarningIcon } from '../../svgs/icons/WarningIcon';
import { styleSheet } from './styles';

interface IProps {
	isOpen: boolean;
	onRequestClose: () => void;
	onSubmit: (reason: string, rejectionCategory: RejectionCategory) => void;
}

export const TemplateRejectionModal = ({ isOpen, onRequestClose, onSubmit }: IProps) => {
	const [rejectionCategory, setRejectionCategory] = useState<RejectionCategory>(null);
	const [reasonText, setReasonText] = useState('');

	const handleSave = () => {
		if (rejectionCategory) {
			onSubmit(reasonText, rejectionCategory);
			onRequestClose();
		}
	};

	const handleCancel = () => {
		onRequestClose();
	};

	const rejectionOptions = Object.values(RejectionCategory).map(category => ({
		title: category,
		value: category,
	})) as ISelectBoxOption<RejectionCategory>[];

	const handleCategoryChange = (option: ISelectBoxOption<RejectionCategory>) => {
		setRejectionCategory(option.value!);
	};

	const isSaveDisabled = !rejectionCategory || (rejectionCategory === RejectionCategory.Other && !reasonText.trim());

	return (
		<Modal isOpen={isOpen} useDefaultHeader={true} onRequestClose={onRequestClose}>
			<div className={css(styleSheet.modal)}>
				<figure className={css(styleSheet.modalIcon)}>
					<WarningIcon />
				</figure>

				<h5 className={css(styleSheet.modalTitle)}>Campaign Rejected</h5>

				<section className={css(styleSheet.modalDescription)}>
					<div className={css(styleSheet.formGroup)}>
						<label htmlFor='rejectionReason'>Reason for rejection</label>
						<SelectBox
							placeholder={<span>Select a reason...</span>}
							options={rejectionOptions}
							selectedOption={rejectionOptions.find(option => option.value === rejectionCategory)}
							onSelectionChanged={handleCategoryChange}
							menuClassName={css(styleSheet.selectBoxMenu)}
							triggerStyles={[styleSheet.selectBoxTrigger]}
							menuStyles={[styleSheet.selectBoxMenu]}
							className={css(styleSheet.selectBoxContainer)}
						/>
					</div>
					<div className={css(styleSheet.formGroup)}>
						<label htmlFor='rejectionNote'>Add a note</label>
						<textarea
							id='rejectionNote'
							className={css(styleSheet.textarea)}
							value={reasonText}
							onChange={e => setReasonText(e.target.value)}
						/>
					</div>
				</section>

				<footer className={css(styleSheet.footer)}>
					<button className={css(baseStyleSheet.ctaButton)} onClick={handleSave} disabled={isSaveDisabled}>
						<span>Save</span>
					</button>
					<button className={css(baseStyleSheet.ctaButtonReverse)} onClick={handleCancel}>
						<span>Cancel</span>
					</button>
				</footer>
			</div>
		</Modal>
	);
};
